export const prestationsQueryKeys = {
  all: ["prestations"] as const,
  lists: () => [...prestationsQueryKeys.all, "lists"] as const,
  list: (filters: object) => [...prestationsQueryKeys.lists(), { filters }] as const,
  names: () => [...prestationsQueryKeys.all, "names"] as const,
};
